import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import BrandIcon from '../../components/BrandIcon';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function DeliveryBrands() {
  const nav = useNavigate();
  const { user, setUser } = useAuth();
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState(user?.brands || []);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/brands').then(response => setBrands(response.data)).catch(() => {
      toast.error('Erro ao carregar marcas');
    });
  }, []);

  const toggleBrand = (brandId) => {
    setSelectedBrands(current => (
      current.includes(brandId)
        ? current.filter(id => id !== brandId)
        : [...current, brandId]
    ));
  };

  const saveBrands = async () => {
    if (selectedBrands.length === 0) {
      toast.error('Selecione ao menos uma marca');
      return;
    }

    setSaving(true);
    try {
      const response = await api.put('/delivery/brands', { brands: selectedBrands });
      setUser(response.data);
      toast.success('Marcas atualizadas com sucesso');
      nav('/entregador/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao salvar marcas');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="screen bg-gray-900 text-white flex flex-col">
      <div className="px-6 pt-12 pb-6">
        <button onClick={() => nav('/entregador/dashboard')} className="text-2xl mb-4 block">←</button>
        <h1 className="text-2xl font-black">Marcas atendidas</h1>
        <p className="text-gray-400 text-sm mt-1">Adicione ou remova as marcas que você trabalha</p>
      </div>

      <div className="flex-1 px-4 overflow-y-auto pb-6">
        <div className="grid grid-cols-2 gap-3">
          {brands.map(brand => {
            const active = selectedBrands.includes(brand.id);
            return (
              <button
                key={brand.id}
                onClick={() => toggleBrand(brand.id)}
                className={`rounded-2xl p-4 border-2 transition-all text-left ${active ? 'border-primary bg-orange-50 text-gray-900' : 'border-gray-700 bg-gray-800 text-white'}`}
              >
                <div className="flex items-center gap-3">
                  <BrandIcon brandId={brand.id} size={42} />
                  <div className="flex-1">
                    <div className="font-black text-sm">{brand.name}</div>
                    <div className={`text-xs ${active ? 'text-gray-500' : 'text-gray-400'}`}>
                      {active ? 'Ativa para receber pedidos' : 'Toque para ativar'}
                    </div>
                  </div>
                  <div className={`text-lg font-black ${active ? 'text-primary' : 'text-gray-500'}`}>
                    {active ? '✓' : '+'}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <button
          onClick={saveBrands}
          disabled={saving}
          className="w-full mt-6 py-4 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-2xl font-bold text-white text-lg transition-all active:scale-95"
        >
          {saving ? 'Salvando...' : 'Salvar marcas'}
        </button>
      </div>
    </div>
  );
}